import { z } from 'zod';
import { messageKey } from './messages.js';
import { permissionSchema } from './permissions.js';
/**
 * Требования к паролю.
 *
 * Верхняя граница в 128 символов — не придирка к пользователю, а защита:
 * argon2id считает хеш от строки любой длины, и мегабайтный пароль
 * превратится в отказ в обслуживании на этапе входа.
 */
export const passwordSchema = z
    .string()
    .min(12, messageKey('validation.password.tooShort', { min: 12 }))
    .max(128, messageKey('validation.password.tooLong', { max: 128 }));
/**
 * Адрес приводится к нижнему регистру до проверки: в БД колонка объявлена
 * как CITEXT, и хранить один и тот же адрес в разном регистре нельзя.
 * 254 символа — предел длины адреса по RFC 5321.
 */
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email(messageKey('validation.email.invalid')).max(254));
export const loginRequestSchema = z.object({
    email: emailSchema,
    // На входе пароль не валидируется по длине: правила могли измениться
    // после того, как пользователь его задал, а отказ должен быть один и тот же.
    password: z.string().min(1).max(128),
});
export const authUserSchema = z.object({
    id: z.uuid(),
    orgId: z.uuid(),
    email: z.string(),
    displayName: z.string(),
    /** Пользователь обязан сменить временный пароль, выданный администратором. */
    mustChangePassword: z.boolean(),
});
export const loginResponseSchema = z.object({
    accessToken: z.string(),
    /** Секунды до истечения access-токена. Фронт обновляет его заранее. */
    expiresInSec: z.number().int().positive(),
    user: authUserSchema,
});
export const refreshResponseSchema = z.object({
    accessToken: z.string(),
    expiresInSec: z.number().int().positive(),
});
/** Ответ `GET /auth/me` — профиль и итоговый набор прав (ТЗ §8.2). */
export const meResponseSchema = z.object({
    user: authUserSchema,
    permissions: z.array(permissionSchema),
    roles: z.array(z.object({ id: z.uuid(), name: z.string() })),
    organization: z.object({ id: z.uuid(), name: z.string(), slug: z.string() }),
});
export const changePasswordRequestSchema = z.object({
    currentPassword: z.string().min(1).max(128),
    newPassword: passwordSchema,
});
/**
 * Полезная нагрузка access-токена.
 *
 * Права в токен не кладутся намеренно: при отзыве роли токен продолжал бы
 * действовать до истечения TTL. Права читаются на каждом запросе.
 */
export const accessTokenPayloadSchema = z.object({
    /** subject — идентификатор пользователя. */
    sub: z.uuid(),
    /** Организация берётся только отсюда, не из тела запроса (ТЗ §8.1). */
    org: z.uuid(),
    iat: z.number().int(),
    exp: z.number().int(),
});
//# sourceMappingURL=auth.js.map